import { render, staticRenderFns } from "./bgContain.vue?vue&type=template&id=50c2d8b2&scoped=true&"
import script from "./bgContain.vue?vue&type=script&lang=js&"
export * from "./bgContain.vue?vue&type=script&lang=js&"
import style0 from "./bgContain.vue?vue&type=style&index=0&id=50c2d8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2d8b2",
  null
  
)

component.options.__file = "bgContain.vue"
export default component.exports